/* eslint react/prop-types: 0 */
import React from 'react';
import { formatMoney } from '../../../utils/money';
import { HorseLink } from '../../../shared/links/ProfileLink';
import HorseCell from '../components/HorseCell';
import Abbr from '../../../shared/Abbr';

const columns = [
    {
        key: 'horseName',
        header: () => (
            <Abbr title="horse">
                horse / sire
            </Abbr>
        ),
        cell: HorseCell,
        sortFn: 'alphabetic',
    },
    {
        key: 'sireStyleName',
        header: 'sire',
        cell: ({ sireStyleName, sireUid, sireCountryOriginCode }) => (
            <span>
                <HorseLink
                    className="ui-link_marked"
                    horseStyleName={sireStyleName}
                    horseUid={sireUid}
                />
                {
                    sireCountryOriginCode ? (
                        <span>{` (${sireCountryOriginCode})`}</span>
                    ) : null
                }
            </span >
        ),
        sortFn: 'alphabetic',
    },
    {
        key: 'wins',
        header: () => (
            <Abbr title="wins">
                wins / runs
            </Abbr>
        ),
        cell: ({ wins, runs }) => (
            <span>
                <strong>{wins}</strong>
                <span className="hidden-sm-up">/{runs}</span>
            </span>
        ),
    },
    {
        key: 'runs',
    },
    {
        key: 'winPercent',
        header: '%',
    },
    {
        key: 'places',
        header: 'placed',
    },
    {
        key: 'totalPrizeMoney',
        header: 'total earnings',
        cell: ({ totalPrizeMoney }) => formatMoney(totalPrizeMoney),
    },
    {
        key: 'bestOr',
        header: 'best or',
    },
    {
        key: 'rpPostmark',
        header: 'best rpr',
    },
];

export default columns;



// WEBPACK FOOTER //
// ./src/js/horse/progeny/damsSire/columns.jsx